export default __webpack_public_path__ + "static/media/health.77bbb66a.png";